import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function updateUserRole(
  userId: string,
  role: string
) {
  try {
    const res = await apiFetch(
      `${API_URL}/users/${userId}/role?role=${role}`,
      {
        method: "PATCH",
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się zaktualizować roli użytkownika.")
      );
    }

    return res.json();
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się zaktualizować roli użytkownika");
  }
}

export async function toggleUserActive(userId: string, active: boolean) {
  try {
    const endpoint = active
      ? `/users/${userId}/activate`
      : `/users/${userId}/deactivate`;

    const res = await apiFetch(`${API_URL}${endpoint}`, {
      method: "PATCH",
    });

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się zaktualizować statusu użytkownika.")
      );
    }
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się zaktualizować statusu użytkownika");
  }
}

export async function getUsers() {
 try {
  const res = await apiFetch(`${API_URL}/users`, {
    method: "GET",
  });

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać listy użytkowników.")
    );
  }

  return res.json();
 } catch (e) {
   throw normalizeFetchError(e, "Nie udało się pobrać listy użytkowników");
 }
}
